import SelectBox from "devextreme-react/select-box";
import CheckBox from "devextreme-react/check-box";
import TextBox from "devextreme-react/text-box";
import DateBox from "devextreme-react/date-box";
import Button from "devextreme-react/button";
import TextArea from "devextreme-react/text-area";
import axios from "axios";
import ValidationSummary from "devextreme-react/validation-summary";
import {
  Validator,
  RequiredRule,
  CompareRule,
  EmailRule,
  PatternRule,
  StringLengthRule,
  RangeRule,
  AsyncRule,
} from "devextreme-react/validator";
import icon from "../Assets/chat.png";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import notify from "devextreme/ui/notify";
import { config } from "../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretSquareRight } from "@fortawesome/free-solid-svg-icons";
import api from "../request/api";
import ReactHtmlParser from "react-html-parser";
import baner from "../Assets/baner.png";
import { Portal } from "../_components/Portal";
import { HtmlContentEditor } from "../_components/HtmlContentEditor";

const Answer = () => {
  const history = useHistory();

  const [feedbackId, setFeedbackId] = useState();
  const [feedback, setFeedback] = useState([]);
  const [contentText, setContentText] = useState();
  const [isAnswer, setIsAnswer] = useState(false);

  useEffect(async () => {
    setFeedbackId(
      window.location.href.substring(window.location.href.lastIndexOf("/") + 1)
    );
    const { data } = await api.get(
      config.apiUrl +
      "Feedback/GetContentForAnswerById" +
      "?id=" +
      window.location.href.substring(
        window.location.href.lastIndexOf("/") + 1
      )
    );
    console.log(data);
    setFeedback(data);
  }, []);

  const sendAnswer = async () => {
    const param = {
      id: feedbackId,
      content: contentText,
    };

    const { data } = await api.post(
      config.apiUrl + "Feedback/AddAnswer",
      param
    );
    setIsAnswer(true);
    notify("Zapisano i przesłano odpowiedź. Dziękujemy.", "error", 5000);
  };

  return (
    <>
      <div className="card">
        <div className="col-12">
          <div
            className="mainHeader"
            style={{ backgroundImage: `url(${baner})` }}
          >

          </div>
        </div>
      </div>

      <div className="answerSection">
        {feedback && (
          <div className="card">
            <div className="col-12 secendaryHeader">
              <span className="secendaryHeaderText">
                Sprawa o numerze: {feedback.stringNumber}
              </span>
              <p className="mainHeaderText">Od: {feedback.email}</p>
              <p className="mainHeaderText">
                Dotyczy nieruchomości o adresie :
                <ul>
                  <li>Ulica: {feedback.street}</li>
                  <li>Nr domu: {feedback.house}</li>
                  <li>Nr lokalu: {feedback.apartment}</li>
                </ul>
              </p>
            </div>
            <div className="row">
              <div className="mainHeaderText">
                Treść: {ReactHtmlParser(feedback.content)}
              </div>
            </div>
          </div>
        )}
        <hr />
        <div className="card">
          <div className="row">
            <div className="col-12">
              <div className="mainHeader">Udziel odpowiedzi</div>
            </div>

            <div className="section">
              <div className="col-12 secendaryHeader">
                <span className="secendaryHeaderText">Treść odpowiedzi</span>
              </div>
              <HtmlContentEditor
                value={contentText}
                setValue={setContentText}
                disabled={false}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end buttonSection">
          {isAnswer == false ? (
            <div className="d-flex justify-content-center">
              <Button
                id="button"
                text="Wyślij e-Odpowiedź"
                className="buttonSuccess"
                onClick={sendAnswer}
              />
            </div>
          ) : (
            <p className="mainHeaderText">
              Do tej wiadomości została już udzielona odpowiedź.
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export { Answer };
